const applyPolyfills = (): void => {
  /* eslint-disable */
  if (!Object.entries) {
    Object.entries = function(obj: object) {
      const ownProps = Object.keys(obj);
      let i = ownProps.length;
      const resArray = new Array(i); // preallocate the Array

      while (i--) {
        // @ts-ignore
        resArray[i] = [ownProps[i], obj[ownProps[i]]];
      }

      return resArray;
    };
  }

  if (!('remove' in Element.prototype)) {
    // @ts-ignore
    Element.prototype.remove = function() {
      // @ts-ignore
      if (this.parentNode) {
        // @ts-ignore
        this.parentNode.removeChild(this);
      }
    };
  }
};

export default applyPolyfills;
